import { useUserStore } from '~/store/userStore'
import { UserAuthGroup } from '~/enums'
import routerJson from '@/assets/data/router.json'
import { getDesignTocRoute, allReplaceComponent } from '~/app/router.options'

export const useDynamicRouter = () => {
  const userStore = useUserStore()

  const updateRouter = async () => {
    const userAuthGroup = userStore.loginUserInfo?.authGroupSeq
    if (!userAuthGroup) {
      console.warn('updateRouter: userAuthGroup is not available')
      return
    }

    const router = useRouter()
    const designTocRoute = router.getRoutes().find((route: any) => route.name === 'design-toc')
    
    if (designTocRoute) {
      // 기존 라우트 제거
      router.removeRoute('design-toc')
      
      // router.options.ts의 getDesignTocRoute 함수를 사용하여 새로운 라우트 생성
      const newDesignTocRoute = getDesignTocRoute(userAuthGroup)
      
      // console.log('Creating new design-toc route with permission:', userStore.userRoutePermission)
      // console.log('New route structure:', JSON.stringify(newDesignTocRoute, null, 2))
      
      // 새 라우트 추가
      router.addRoute('page', newDesignTocRoute)
      
      // 라우터 업데이트 완료를 기다림
      await nextTick()
      await new Promise(resolve => setTimeout(resolve, 100))
      
      // 업데이트 후 등록된 라우트들 확인
      const updatedRoutes = router.getRoutes().filter((route: any) => String(route.name)?.includes('design-toc'));
      const dashboardRoutes = router.getRoutes().filter((route: any) => 
        String(route.name)?.includes('dashboard-site-default-equip-equipid')
      )
      const sitesRoutes = router.getRoutes().filter((route: any) => 
        String(route.name)?.includes('sites-detail')
      )
      
      // console.log('Updated routes after router update:', updatedRoutes.map((r: any) => r.name));
      // console.log('Dashboard equip routes:', dashboardRoutes.map((r: any) => r.name));
      // console.log('Sites detail routes:', sitesRoutes.map((r: any) => r.name));
      
      // console.log('Router updated successfully using router.options.ts logic', {
      //   userAuthGroup,
      //   userRoutePermission: userStore.userRoutePermission,
      //   availableRoutes: updatedRoutes.map((r: any) => r.name),
      //   sitesRoutes: sitesRoutes.map((r: any) => r.name)
      // })
    } else {
      console.warn('updateRouter: design-toc route not found, creating new route')
      const newDesignTocRoute = getDesignTocRoute(userAuthGroup)
      router.addRoute('page', newDesignTocRoute)
      await nextTick()
      await new Promise(resolve => setTimeout(resolve, 100))
    }
  }

  const waitForRouteUpdate = async (routeName: string, maxAttempts = 40) => {
    const router = useRouter()
    
    // 스토어 상태가 업데이트될 때까지 잠시 대기
    await new Promise(resolve => setTimeout(resolve, 200))
    
    for (let i = 0; i < maxAttempts; i++) {
      const route = router.getRoutes().find((r: any) => r.name === routeName)
      if (route) {
        console.log(`Route ${routeName} found after ${i + 1} attempts`)
        return true
      }
      // 대기 간격을 100ms로 증가하여 라우터 생성 시간 확보
      await new Promise(resolve => setTimeout(resolve, 100))
    }
    
    // 라우터를 찾지 못한 경우 디버깅 정보 출력
    const allRoutes = router.getRoutes()
    const dashboardRoutes = allRoutes.filter((r: any) => 
      String(r.name)?.includes('dashboard') || String(r.name)?.includes('equip')
    )
    const sitesRoutes = allRoutes.filter((r: any) => 
      String(r.name)?.includes('sites')
    )
    // console.warn(`Route ${routeName} not found after ${maxAttempts} attempts (total wait time: ${200 + (maxAttempts * 100)}ms)`)
    // console.warn('Available dashboard/equip routes:', dashboardRoutes.map((r: any) => r.name))
    // console.warn('Available sites routes:', sitesRoutes.map((r: any) => r.name))
    // console.warn('All routes:', allRoutes.map((r: any) => r.name))
    
    return false
  }

  return {
    updateRouter,
    waitForRouteUpdate,
    getDesignTocRoute // 외부에서도 사용할 수 있도록 export
  }
}
